import { getAuthoredOverview, renderAuthoredNarrativeBundle } from './authoredNarrativeRender';
import type { DepartureNarrativeFacts } from './departureTimeNarrativeFacts';

const CHART_ID = 'departure_time';
const VIEW_ID = 'default';

export function buildDepartureTimeAuthoredBundle(locationName: string, facts: DepartureNarrativeFacts) {
  const earlyLateSentence =
    facts.before7amShare != null &&
    facts.after9amShare != null &&
    (facts.before7amShare > 0 || facts.after9amShare > 0)
      ? ` About ${facts.before7amShare}% left before 7:00 a.m. and ${facts.after9amShare}% at or after 9:00 a.m.`
      : '';
  const tokens = {
    locationName,
    latestYear: facts.latestYear,
    dominantDepartureWindow: facts.dominantDepartureWindow,
    dominantDepartureShare: facts.dominantDepartureShare,
    earlyLateSentence,
  };
  return renderAuthoredNarrativeBundle(CHART_ID, VIEW_ID, tokens);
}

export function departureTimeOverviewDescription(): string {
  return getAuthoredOverview(CHART_ID, VIEW_ID, 'ACS departure time to work by time window.');
}

export function buildDepartureTimeKeyInsights(
  locationName: string,
  facts: DepartureNarrativeFacts
): string {
  const bundle = buildDepartureTimeAuthoredBundle(locationName, facts);
  return bundle.keyInsights || `Departure time data are not available for ${locationName}.`;
}
